import { ComponentType, SVGProps } from "react";

import { ReactComponent as CheckSvg } from "./check.svg";
import { ReactComponent as CloseSvg } from "./close.svg";
import { ReactComponent as DropdownSvg } from "./dropdown.svg";
import { ReactComponent as ErrorSvg } from "./error.svg";
import { ReactComponent as EyeSvg } from "./eye.svg";
import { ReactComponent as EyeOffSvg } from "./eye-off.svg";
import { ReactComponent as InfoSvg } from "./info.svg";
import { ReactComponent as PerfectlySvg } from "./perfectly.svg";
import { ReactComponent as TickSvg } from "./tick.svg";
import { ReactComponent as WarningSvg } from "./warning.svg";

export type SvgIconComponent = ComponentType<SVGProps<SVGSVGElement>>;

/** Map icon file names (without extension) to SVGR React components. */
export const iconRegistry = {
  check: CheckSvg,
  close: CloseSvg,
  dropdown: DropdownSvg,
  error: ErrorSvg,
  eye: EyeSvg,
  "eye-off": EyeOffSvg,
  info: InfoSvg,
  perfectly: PerfectlySvg,
  tick: TickSvg,
  warning: WarningSvg,
} as const satisfies Record<string, SvgIconComponent>;

export type IconName = keyof typeof iconRegistry;

export function isIconName(value: string): value is IconName {
  return value in iconRegistry;
}
